/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Clear_FieldsInputs */

const cs_property_ai_clear_fields = /** @type {(inputs: Property_Ai_Clear_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit pole`)
};

const en_property_ai_clear_fields = /** @type {(inputs: Property_Ai_Clear_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear fields`)
};

/**
* | output |
* | --- |
* | "Clear fields" |
*
* @param {Property_Ai_Clear_FieldsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_clear_fields = /** @type {((inputs?: Property_Ai_Clear_FieldsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Clear_FieldsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_clear_fields(inputs)
	return cs_property_ai_clear_fields(inputs)
});